export const UPDATE_CHANNEL = 'UPDATE_CHANNEL'
export const UPDATE_CHANNEL_ID = 'UPDATE_CHANNEL_ID'
export const UPDATE_PAGE = 'UPDATE_PAGE'
export const UPDATE_PAGES = 'UPDATE_PAGES'
export const UPDATE_PAGE_ID = 'UPDATE_PAGE_ID'
export const UPDATE_PAGE_TITLE = 'UPDATE_PAGE_TITLE'
export const UPDATE_TIER = 'UPDATE_TIER'
export const UPDATE_TIERS = 'UPDATE_TIERS'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_FANS = 'UPDATE_FANS'
export const CONFIRM_DELETE = 'CONFIRM_DELETE'
export const PAGE_DELETED = 'PAGE_DELETED'
